interface ErrorBannerProps {
  error: unknown
  onDismiss?: () => void
}

function asMessage(err: unknown): string {
  if (!err) return ''
  if (err instanceof Error) return err.message
  if (typeof err === 'string') return err
  return JSON.stringify(err)
}

export default function ErrorBanner({ error, onDismiss }: ErrorBannerProps) {
  if (!error) return null
  return (
    <div className="border border-destructive-soft bg-destructive-soft text-destructive-soft-foreground text-sm rounded px-3 py-2 flex items-start gap-2">
      <span className="flex-1">{asMessage(error)}</span>
      {onDismiss && (
        <button
          type="button"
          className="text-destructive-soft-foreground hover:text-destructive"
          onClick={onDismiss}
        >
          ×
        </button>
      )}
    </div>
  )
}
